import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import useWindowSize from "customHooks/useWindowSize";
import { useApps } from "pages/home/AppProvider";
import { useNavigate } from 'react-router-dom';
import Body from "./components/Body";

const Summary: React.FC = () => {
  const [, windowHeight] = useWindowSize();
  const [headerHeight, setHeaderHeight] = useState<number | undefined>(0);
  const [bodyHeight, setBodyHeight] = useState<number>(0);
  const { summaryApp, apps } = useApps();
  const navigate = useNavigate();

  useEffect(() => {
    setBodyHeight(windowHeight - (headerHeight ?? 0));
  }, [windowHeight, headerHeight]);

  useEffect(()=>{
    if(!apps || Object.keys(apps).length === 0) return;
    if(summaryApp !== null) return;
    navigate(`/${Object.keys(apps)[0]}`);
  }, [summaryApp, navigate, apps]);

  return (
    <>
      <Header setHeaderHeight={setHeaderHeight} headerHeight={headerHeight} />
      {!!summaryApp && <Body bodyHeight={bodyHeight} summaryApp={summaryApp} />}
    </>
  );
};

export default Summary;
